import React, { useEffect, useState } from "react";
import careercarousel3 from "../../../Assets/careerscarousels3.png";
import careercarousel2 from "../../../Assets/careercarousel2.png";
import careercarousel1 from "../../../Assets/careercarousel1.png";
import diversity from "../../../Assets/diversity.png";
import careerContact from '../../../Assets/careerContact.jpg'
import careerContactSmall from '../../../Assets/careerBannerSmall.jpg'
import { useScrollAnimation } from "../../../utils/Utils";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import jobsData from '../../../utils/Jobs.json';
import CareerHeroWithCursor from "./Intro";
import CareerProgramTicker from "./CareerProgramTicker";
import Program from "./InforTraining/Program";


const Career = () => {
  const [currentSlide, setCurrentSlide] = useState(1);
  const totalSlides = 3; // Total number of slides in the carousel
 
  // Function to handle changing slides
  const handleSlideChange = (slideNumber) => {
    setCurrentSlide(slideNumber);
  };

  // Auto-scroll functionality using useEffect
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevSlide) =>
        prevSlide === totalSlides ? 1 : prevSlide + 1
      );
    }, 5000); // Change slides every 3 seconds

    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [totalSlides]);

  useScrollAnimation();

  const careerlist = [
    {
      position: "Software Developer",

      description:
        "Install, configursdgfdge, and upgrade database server software. Implement and maintain database design and security. Perform tuning and performancedgs monitoring. Conduct data profiling and data mapping. Write database queries and design reports.",
      requirements:
        " Install, configure, andsdgsdgdsgsd upgrade database server software. Implement and maintain database design and security. Perform tuning and performancsdgfsgfe monitoring. Conduct data profiling and data mapping. Write database queries and design reports.",
    },
    {
      position: "Software Developer",

      description:
        "Install, configursdgfdge, and upgrade database server software. Implement and maintain database design and security. Perform tuning and performancedgs monitoring. Conduct data profiling and data mapping. Write database queries and design reports.",
      requirements:
        " Install, configure, andsdgsdgdsgsd upgrade database server software. Implement and maintain database design and security. Perform tuning and performancsdgfsgfe monitoring. Conduct data profiling and data mapping. Write database queries and design reports.",
    },
    {
      position: "Software Developer",

      description:
        "Install, configursdgfdge, and upgrade database server software. Implement and maintain database design and security. Perform tuning and performancedgs monitoring. Conduct data profiling and data mapping. Write database queries and design reports.",
      requirements:
        " Install, configure, andsdgsdgdsgsd upgrade database server software. Implement and maintain database design and security. Perform tuning and performancsdgfsgfe monitoring. Conduct data profiling and data mapping. Write database queries and design reports.",
    },
    {
      position: "Software Developer",

      description:
        "Install, configursdgfdge, and upgrade database server software. Implement and maintain database design and security. Perform tuning and performancedgs monitoring. Conduct data profiling and data mapping. Write database queries and design reports.",
      requirements:
        " Install, configure, andsdgsdgdsgsd upgrade database server software. Implement and maintain database design and security. Perform tuning and performancsdgfsgfe monitoring. Conduct data profiling and data mapping. Write database queries and design reports.",
    },
    {
      position: "Software Developer",

      description:
        "Install, configursdgfdge, and upgrade database server software. Implement and maintain database design and security. Perform tuning and performancedgs monitoring. Conduct data profiling and data mapping. Write database queries and design reports.",
      requirements:
        " Install, configure, andsdgsdgdsgsd upgrade database server software. Implement and maintain database design and security. Perform tuning and performancsdgfsgfe monitoring. Conduct data profiling and data mapping. Write database queries and design reports.",
    },
  ];

  const navigate = useNavigate();

  return (
    <div className="bg-[#fff] font-md">

      {/* <CareerHeroWithCursor/> */}

      <CareerProgramTicker />
      <Program/>

    {/* <section className="py-16 lg:py-28 px-4">
      <div className="container mx-auto max-w-6xl">
        <div className="flex items-center mb-6">
          <span
          className="font-semibold py-3 px-6 rounded-full shadow-lg"
          style={{
            background: "linear-gradient(to right, #243748, #4b749f)", // purple-500 → pink-500
            color: "#ffffff",
          }}
          >
            PT KCS Careers
          </span>
        </div>

        <h1
          className="text-4xl md:text-5xl mb-6 leading-tight font-dm"
          style={{ color: "#4B5563" }} // indigo-900
        >
          Build Your Future With PT KCS
        </h1>

        <p
          className="text-base leading-relaxed animate-up"
          style={{ color: "#4b5563",wordBreak: 'normal',overflowWrap: 'normal',hyphens: 'none',whieSpace: 'normal' }} // gray-600
        >
        At PT KCS, we believe that great technology is built by great people. We empower our teams with the tools, trust, and freedom to innovate, collaborate, and grow. Whether you're a fresh talent or an experienced professional, PT KCS offers a dynamic environment where your skills are valued, your ideas matter, and your career can truly take off.

        Here, you’ll be part of a culture that encourages curiosity, continuous learning, and bold thinking. We provide opportunities to work on cutting-edge projects, tackle real-world challenges, and make a tangible impact in the technology landscape. Beyond professional growth, we foster a supportive and inclusive workplace where collaboration, creativity, and respect form the foundation of everything we do.

        Join PT KCS, and be part of a community that celebrates innovation, nurtures talent, and drives technology forward. Your journey with us is not just a job—it’s a chance to shape the future, expand your horizons, and achieve your full potential. </p>
      </div>
    </section> */}






  {/* <section>
    <div className="banner-area slider-height">
      <img className="w-100 slider-desk" src={careercarousel3} alt="Kapil Technologies is ranked among the Top 100 Great Places to Work!"/>
		<img className="w-100 slider-mob" src="https://www.Kapil Technologies.com/sites/default/files/gptw-rank-mobile-banner.jpg" alt="Kapil Technologies is ranked among the Top 100 Great Places to Work!"/>
		
		<div className="para">
		<h1>Kapil Technologies is ranked among the<br/><span class="red-light-text locator-font-bold">Top 100 Great Places to Work!</span></h1>
		</div>
    </div>
   
    <div className="career_main relative">
      <img
        className="w-full hidden lg:block"
        src={careerContact}
        alt="Kapil Technologies is ranked among the Top 100 Great Places to Work!"
      />
    
      <img
        className="w-full block lg:hidden"
        src={careerContactSmall}
        alt="Kapil Technologies is ranked among the Top 100 Great Places to Work!"
      />
      
      <h1 className="lg:ps-12 career_banner ">
        Kapil Technologies is in the <br/> Top 100 Best Workplaces!
      </h1>
    </div>
  </section> */}


      {/* <section className="py-10">
        <h2 className="text-center pb-10 animate-up">Meet the Challengers</h2>
        <div
          id="default-carousel"
          className="relative flex justify-center"
          data-carousel="static"
        >
          
          <div
            className={`duration-700 ease-in-out inset-0 transition-transform transform xl:mx-36 mx-3 md:mx-10 ${
              currentSlide === 1 ? "translate-x-0" : "translate-x-full"
            }`}
            style={{ display: currentSlide === 1 ? "block" : "none" }}
          >
            <img
              src={careercarousel3}
              alt="Slide 1"
              className="w-full h-auto object-cover"
            />
          </div>

          
          <div
            className={`duration-700 ease-in-out inset-0 transition-transform transform xl:mx-36 mx-3 md:mx-10 ${
              currentSlide === 2 ? "translate-x-0" : "translate-x-full"
            }`}
            style={{ display: currentSlide === 2 ? "block" : "none" }}
          >
            <img
              src={careercarousel1}
              alt="Slide 2"
              className="w-full h-auto object-cover"
            />
          </div>

       
          <div
            className={`duration-700 ease-in-out inset-0 transition-transform transform xl:mx-36 mx-3 md:mx-10 ${
              currentSlide === 3 ? "translate-x-0" : "translate-x-full"
            }`}
            style={{ display: currentSlide === 3 ? "block" : "none" }}
          >
            <img
              src={careercarousel2}
              alt="Slide 3"
              className="w-full h-auto object-cover"
            />
          </div>

          
          <div className="absolute z-30 flex -translate-x-1/2 bottom-5 left-1/2 space-x-3 rtl:space-x-reverse">
            {[1, 2, 3].map((slide) => (
              <button
                key={slide}
                type="button"
                className={`w-3 h-3 rounded-full ${
                  currentSlide === slide ? "bg-white" : "bg-black"
                }`}
                aria-current={currentSlide === slide}
                aria-label={`Slide ${slide}`}
                onClick={() => handleSlideChange(slide)}
              ></button>
            ))}
          </div>
        </div>
      </section> */}


    {/*JOB Cards Section------------------------- */}
    {/* <section id="open-positions" className="mx-auto max-w-8xl py-10 bg-[#ffffff]">
      <h1 className="text-center text-4xl md:text-5xl mb-10 leading-tight font-dm" style={{color:'#4B5563'}}>
       Join the PT KCS Team – Open Positions
      </h1>

      <div className="xl:mx-40 mx-3 md:mx-10 animate-up">
        <h3 className="text-2xl pb-2 font-md" style={{color:'#4B5563'}}>Multiple positions</h3>
        <hr className="border-[#cbd5e1] pb-6" />
      </div>

      {jobsData.jobs.map((items) => (
        <div
          key={items.jobId}
          className="grid grid-cols-1 lg:grid-cols-2 gap-7 xl:mx-40 mx-3 md:mx-10"
        >

          <div className="col-span-1 animate-up mb-6 flex flex-col justify-between">
            <div>
              <h4 className="font-man font-bold text-2xl pb-1" style={{color:'#0070FF'}}>
                {items.jobTitle}
              </h4>

              <p>
                <span className="font-man font-extrabold text-md">Job Category: </span>
                {items.category}
              </p>

              <p>
                <span className="font-man font-extrabold text-md">Job Location: </span>
                {items.location}
              </p>

              {typeof items.openings === "number" && (
                <p>
                  <span className="font-man font-extrabold text-md">Openings: </span>
                  {items.openings}
                </p>
              )}
            </div>

            <hr className="border-[#cbd5e1]" />
          </div>

          <div className="col-span-1 animate-up mb-6 flex flex-col justify-between">
            <div>
              <p>
                <span className="font-man font-extrabold text-md" style={{wordBreak: 'normal',overflowWrap: 'normal',hyphens: 'none',whieSpace: 'normal'}}>Job Summary: </span>
                {items.jobSummary}
              </p>
            </div>

          <div>
            <button
              onClick={() => {
                window.scrollTo(0, 0);
                navigate(`/career/position_description/${items.jobId}`);
              }}
              className="border border-[#fff] rounded-md px-3 py-2 mb-4 text-[#fff] bg-[#468FEA] hover:bg-[#0000FF]"
            >
              I'm Interested
            </button>
          </div>


            <hr className="border-[#cbd5e1]" />
          </div>
        </div>
      ))}
    </section> */}


  {/* <section className="py-12 px-4">
    <div className="container mx-auto max-w-6xl">
      
      <div className="flex items-center mb-6">
        <span
          className="font-semibold py-3 px-6 rounded-full shadow-lg"
          style={{
            background: "linear-gradient(to right, #243748, #4b749f)", 
            color: "#ffffff",
          }}

        >
          Company Benefits
        </span>
      </div>
    

      <div className="flex flex-col lg:flex-row items-center gap-12">
        
        <div className="lg:w-1/2">
          <h1
            className="text-4xl md:text-5xl mb-6 leading-tight font-dm"
            style={{ color: "#4B5563" }} 
          >
            We Provide Awesome Benefits For Employees
          </h1>

          <p
            className="text-base leading-relaxed mb-8 animate-up"
            style={{ color: "#4B5563",wordBreak: 'normal',overflowWrap: 'normal',hyphens: 'none',whieSpace: 'normal' }} 
          >
            At PT KCS, we believe our people are our greatest strength. We provide a positive, supportive, and growth-driven work environment where employees feel valued, motivated, and inspired to build long-term careers with us.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            
            {[
              "Positive Work Culture & Friendly Environment",
              "On-site Gym & Fitness Facilities",
              "Relaxation & Indoor Sports Zone",
              "Free Shuttle & Travel Support",
              "Festival & Performance Bonuses",
              "Employee Loyalty Rewards",
              "Annual Team Trips & Outings",
              "Skill Development & Training Programs",
              "Free Meals, Coffee & Snacks",
              "Paid Leave & Leave Encashment"
            ].map((item, index) => (
              <div key={index} className="flex items-start space-x-2 animate-up">
                <img 
                  src="https://ik.imagekit.io/7wqj9br0b/PTKCS/Career%20Page/checklist.png" 
                  alt="Check" 
                  className="w-6 h-6 "
                />
                <span style={{ color: "#4B5563" }}>{item}</span>
              </div>
            ))}

          </div>
        </div>

        <div className="lg:w-1/2">
          <div className=" overflow-hidden shadow-lg">
            <img 
              src="https://ik.imagekit.io/7wqj9br0b/PTKCS/Career%20Page/benefit2.jpg" 
              alt="PT KCS Team Culture" 
              className="w-full h-auto object-cover animate-up"
            />
          </div>
        </div>

      </div>
    </div>
  </section> */}

      {/* <section className="py-10 bg-[#f5f5f5]">
      <h2 className="text-center text-3xl pb-6 animate-up">
        Kapil Technologies, Inc. (Edison, NJ & client sites throughout the US).
      </h2>
      <div className="xl:mx-40 mx-3 md:mx-10 animate-up">
        <h3 className="text-2xl pb-2 font-semibold">Multiple positions</h3>
        <hr className="border-[#cbd5e1] pb-6" />
      </div>
      {careerlist.map((items) => (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-7 xl:mx-40 mx-3 md:mx-10">
          <div className="col-span-1 animate-up mb-6 flex flex-col justify-between">
            <div>
              <h4 className="font-normal text-xl pb-1">{items.position}</h4>
              <p>
                <span className="text-bluecolor text-lg">Job Duties: </span>
                {items.description}
              </p>
            </div>
            <hr className="border-[#cbd5e1] " />
          </div>
          <div className="col-span-1 animate-up mb-6 flex flex-col justify-between">
            <div>
              <p>
                <span className="text-bluecolor text-lg">Requirements: </span>
                {items.requirements}
              </p>
            </div>
            <div>
              <Link to="position_description">
                <button className="border border-[#fff] rounded-md px-3 py-2 mb-4 text-[#fff] bg-bluecolor hover:bg-darkblue">
                  I'm Interested
                </button>
              </Link>
            </div>
            <hr className="border-[#cbd5e1] " />
          </div>
        </div>
      ))}
    </section> */}

      {/* <section className=" py-10">
        <div className="grid grid-col-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-10 xl:mx-40 mx-3 md:mx-10">
          <div>
            <h3 className="text-black pb-7 animate-up">
              Harmonizing Power of AI & Human Centricity
            </h3>
            <div class="video-container">
              <iframe
                width="520"
                height="315"
                src="https://www.youtube.com/embed/UMPXiH-eBXc?si=zvkkks-DHldNKpkB"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>
          </div>
          <div>
            <h3 className="text-black pb-7 animate-up">
              Career Transformation – Neha Aggarwal
            </h3>
            <div class="video-container">
              <iframe
                width="520"
                height="315"
                src="https://www.youtube.com/embed/XZyEjhlJZgo?si=IEZpCZrN8gzXMENl"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
      </section> */}
      {/* <section className="bg-darkblue py-10">
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 gap-7 xl:mx-40 mx-3 md:mx-10">
 
          <div className="flex flex-col justify-between max-w-sm bg-[#092f4f] rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
            <div className="px-5 pt-5 flex-grow">
              <h5 className="mb-2 text-xl font-bold tracking-tight text-[#ffd626] dark:text-white animate-up">
                Diversity, Equity and Inclusion Initiative - Verve
              </h5>
              <p className="mb-3 font-normal text-white dark:text-gray-400 animate-up">
                In an endeavor to become a workplace of choice among people, we
                are striving to create an atmosphere where multiple voices are
                heard, and their opinions are valued and considered..
              </p>
            </div>
          
              <img
                className="rounded-b-lg w-full h-72 object-cover"
                src={diversity}
                alt="diversity"
              />
           
          </div>


          <div className="flex flex-col justify-between max-w-sm bg-[#092f4f] rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
            <div className="px-5 pt-5 flex-grow">
              <h5 className="mb-2 text-xl font-bold tracking-tight text-[#ffd626] dark:text-white animate-up">
                Balancing the Gender Mix
              </h5>
              <p className="mb-3 font-normal text-white dark:text-gray-400 animate-up">
                Referral Recruitment Drive – Exclusively for women to upskill or
                restart their career!
              </p>
            </div>
     
              <img
                className="rounded-b-lg w-full h-72 object-cover"
                src={diversity}
                alt="diversity"
              />
        
          </div>


          <div className="flex flex-col justify-between max-w-sm bg-[#092f4f] rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
            <div className="px-5 pt-5 flex-grow">
              <h5 className="mb-2 text-xl font-bold tracking-tight text-[#ffd626] dark:text-white animate-up">
                Kapil Technologies Recognized as India’s Most Admired & Valuable Power
                Brand Company 2020
              </h5>
              <p className="mb-3 font-normal text-white dark:text-gray-400 animate-up">
                The company was awarded at the India Leadership Conclave 2020
                for having shown remarkable resilience and achievements in a
                very tough and hostile environment.
              </p>
            </div>
           
              <img
                className="rounded-b-lg w-full h-72 object-cover"
                src={diversity}
                alt="diversity"
              />
            
          </div>
        </div>
      </section> */}
      {/* <section className="py-10 bg-[#f5f5f5]">
        <div className="grid grid-col-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-7 xl:mx-40 mx-3 md:mx-10 ">
          <div className="col-span-2 px-4 animate-up">
            <h2 className="pb-5">Equal Opportunity Employer</h2>
            <p>
              As an Equal Opportunity Employer, Kapil Technologies intends to have a
              workforce reflective of the community (gender, cultural
              backgrounds, PwD, veterans) While we consciously strive for a
              gender-balanced hiring from campuses, through our capABLE program
              we also invite persons with disability to connect with us for
              career opportunities. Our Campus is designed to provide facilities
              which are disability friendly and a career canvas which aims to
              provide equal opportunities to everyone.
            </p>
            <p>
              Through our exCITE program, we engage with business schools to
              hire veterans who bring in domain experiences to enrich
              Kapil Technologies’s capabilities.
            </p>
            <p>Why hire for Diversity?</p>
            <ul>
              <li>1. Bigger talent pool to draw from</li>
              <li>2. Increased work ethic/dedication</li>
              <li>
                3. Positively impacts the retention of existing employees and
                boosts employee morale
              </li>
            </ul>
            <button className="border border-[#fff] rounded-md px-3 py-2 mt-5 text-[#fff] bg-bluecolor hover:bg-darkblue">
              Read our policy documents
            </button>
          </div>
          <div className="col-span-1 animate-up">
            <h2 className="pb-5">Great People To Work With</h2>
            <p>
              Our people are our biggest assets and we believe in leaving no
              stone unturned in assuring their wellness at office, as well as at
              home. Our meritocratic culture and processes of regular and timely
              feedback is designed to ensure a warm and supportive environment
              for our people to work in. We encourage our people to volunteer
              actively for cultural events, celebrations, community service
              initiatives and fun at work. This allows them to become better
              employees, better team workers and even better human beings.
            </p>
          </div>
        </div>
      </section> */}

      {/* <section className="py-10 xl:mx-60 mx-3 md:mx-10">
        <figure className="glassdoor_career flex items-center justify-center lg:justify-start p-4 lg:p-10 bg-cover bg-center bg-no-repeat rounded-lg shadow-md">
          <div className="text-center lg:text-left max-w-md mx-auto lg:mx-0">
            <p className="text-lg text-[#4d4d4f] mb-4 animate-up">
              Making Societies More Productive By Helping Our Customers Run
              Their Businesses.
            </p>
            <h2 className="pb-4 text-black text-2xl animate-up">
              We are on Glassdoor
            </h2>
            <button className="rounded-md px-4 py-2 text-white bg-bluecolor hover:bg-darkblue animate-up">
              Know more
            </button>
          </div>
        </figure>
      </section> */}

     
    </div>
  );
};

export default Career;
